module.exports = __webpack_public_path__ + "img/minus-square.ff9b5981.svg";